import React from 'react';

type Props = {};

function Home({}: Props) {
  return <div>Home Page</div>;
}

export default Home;
